import { TASK_STATUS } from './task-status';
import { TICKET_STATUS } from './ticket-status';
/**
 * The only statuses a client ever sees (Architecture Plan §16).
 * Portal DTOs use these; internal statuses are never serialized to clients.
 */
export const CLIENT_VISIBLE_STATUS = {
    RECEIVED: 'RECEIVED',
    ASSIGNED: 'ASSIGNED',
    IN_DEVELOPMENT: 'IN_DEVELOPMENT',
    UNDER_TESTING: 'UNDER_TESTING',
    AWAITING_YOUR_APPROVAL: 'AWAITING_YOUR_APPROVAL',
    SCHEDULED_FOR_RELEASE: 'SCHEDULED_FOR_RELEASE',
    PUBLISHED_LIVE: 'PUBLISHED_LIVE',
    WAITING_FOR_YOU: 'WAITING_FOR_YOU',
    COMPLETED: 'COMPLETED',
    /**
     * Closed without being delivered.
     *
     * Separate from COMPLETED because a client reading "Completed" against a ticket somebody
     * cancelled as a duplicate is being told the work was done. It was not, and the difference is
     * the one they would raise the ticket again over.
     */
    CLOSED: 'CLOSED',
};
export const CLIENT_VISIBLE_STATUS_LABELS = {
    RECEIVED: 'Received',
    ASSIGNED: 'Assigned',
    IN_DEVELOPMENT: 'In development',
    UNDER_TESTING: 'Under testing',
    AWAITING_YOUR_APPROVAL: 'Awaiting your approval',
    SCHEDULED_FOR_RELEASE: 'Scheduled for release',
    PUBLISHED_LIVE: 'Published live',
    WAITING_FOR_YOU: 'Waiting for you',
    COMPLETED: 'Completed',
    CLOSED: 'Closed — not proceeding',
};
const TASK_STATUS_TO_CLIENT = {
    [TASK_STATUS.DRAFT]: CLIENT_VISIBLE_STATUS.RECEIVED,
    [TASK_STATUS.ASSIGNED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TASK_STATUS.BLOCKED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TASK_STATUS.IN_PROGRESS]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.REOPENED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.IN_REVIEW]: CLIENT_VISIBLE_STATUS.UNDER_TESTING,
    [TASK_STATUS.DEV_COMPLETED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.CODE_REVIEW]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.RETURNED_TO_DEV]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.FIX_SUBMITTED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.QA_FAILED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.LIVE_FAILED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.ROLLBACK_REQUIRED]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TASK_STATUS.READY_FOR_QA]: CLIENT_VISIBLE_STATUS.UNDER_TESTING,
    [TASK_STATUS.TESTING_STAGING]: CLIENT_VISIBLE_STATUS.UNDER_TESTING,
    [TASK_STATUS.QA_PASSED]: CLIENT_VISIBLE_STATUS.UNDER_TESTING,
    [TASK_STATUS.CLIENT_UAT]: CLIENT_VISIBLE_STATUS.AWAITING_YOUR_APPROVAL,
    [TASK_STATUS.READY_TO_PUBLISH]: CLIENT_VISIBLE_STATUS.SCHEDULED_FOR_RELEASE,
    [TASK_STATUS.PUBLISHED_LIVE]: CLIENT_VISIBLE_STATUS.PUBLISHED_LIVE,
    [TASK_STATUS.LIVE_VERIFICATION]: CLIENT_VISIBLE_STATUS.PUBLISHED_LIVE,
    [TASK_STATUS.COMPLETED]: CLIENT_VISIBLE_STATUS.COMPLETED,
    [TASK_STATUS.CANCELLED]: CLIENT_VISIBLE_STATUS.CLOSED,
};
const TICKET_STATUS_TO_CLIENT = {
    [TICKET_STATUS.NEW]: CLIENT_VISIBLE_STATUS.RECEIVED,
    [TICKET_STATUS.AUTO_ASSIGNED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TICKET_STATUS.ASSIGNED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TICKET_STATUS.ACKNOWLEDGED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TICKET_STATUS.ESCALATED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TICKET_STATUS.REOPENED]: CLIENT_VISIBLE_STATUS.ASSIGNED,
    [TICKET_STATUS.IN_PROGRESS]: CLIENT_VISIBLE_STATUS.IN_DEVELOPMENT,
    [TICKET_STATUS.REVIEW]: CLIENT_VISIBLE_STATUS.UNDER_TESTING,
    [TICKET_STATUS.WAITING_CLIENT]: CLIENT_VISIBLE_STATUS.WAITING_FOR_YOU,
    [TICKET_STATUS.RESOLVED]: CLIENT_VISIBLE_STATUS.COMPLETED,
    [TICKET_STATUS.CLOSED]: CLIENT_VISIBLE_STATUS.COMPLETED,
    [TICKET_STATUS.CANCELLED]: CLIENT_VISIBLE_STATUS.CLOSED,
};
export function toClientVisibleTaskStatus(status) {
    return TASK_STATUS_TO_CLIENT[status];
}
export function toClientVisibleTicketStatus(status) {
    return TICKET_STATUS_TO_CLIENT[status];
}
//# sourceMappingURL=client-visible-status.js.map